import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: var(--jetbrainsMono-font);
    font-size: 10px;
    user-select: none;
    background-color: white;
    margin: 0;
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: grid;
    grid: min-content auto / 100%;
  }
  * {
    box-sizing: border-box;
  }
`

export default GlobalStyle
